import React from 'react';
import { useQueryClient } from 'react-query';
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Popper from "@material-ui/core/Popper";
import _ from "underscore";

import { useCompanies } from "../../../services/companies";
import {Box} from "@material-ui/core";
import moment from "moment/moment";
import { Text } from '../../../controls';

/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  popper: {
    maxWidth: "fit-content"
  },
});

const formatInputValue = (value, records, alwaysShowCompanyName) => {
  let inputValue= value||"";
  if (records.data) {
    const companyData = _.find(records.data, {companyUuid: value});
    if (companyData) {
      let companyName = companyData.companyName;
      if (companyData.branchCode) {
        companyName = `${companyData.companyName} (${companyData.branchCode})`;
      }
      inputValue = companyData.companyCode||companyName;
      if (alwaysShowCompanyName) {
        inputValue = companyName;
      }
    }
  }
  return inputValue;
}

const CompanyUuidLookup = props => {

  const theme = useTheme();
  const classes = makeStyles(theme => ({
    readOnly: {
      color: theme.palette.text.primary
    }
  }))(theme);

  const companyType = props.companyType;

  const queryClient = useQueryClient();
  const extraKeys = props.atAirport && props.role? [companyType, props.atAirport, props.role]  : props.atAirport ? [companyType, props.atAirport] : [companyType];
  const allRecords = useCompanies({queryClient, useCache: true, extraKeys});
  const records = allRecords?{...allRecords}:allRecords;
  let newCompany = [];
  if (!props.includeNew && records.data && Array.isArray(records.data)){
    records['data'] = _.filter(records.data, {isNew: false});
  }
  if (props.includeNew && records.data && Array.isArray(records.data)){
    newCompany = _.filter(records.data, {isNew: true});
  }
  if (!props.includeFreesale && records.data && Array.isArray(records.data)){
    records['data'] = _.filter(records.data, {isFreesale: false});
  }

  const handleChange = (event, record) => {
    if (event.key === 'Enter') {
      event.stopPropagation()
    }
    if (props.returnType === "object") {
      const returnObject = props.allowEmpty ? { value: null, found: true, data: {companyName: "", companyUuid: null, companyCode: ""} } : { value: null, found: false, data: {} }
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
        returnObject.value = record.companyUuid;
      }
      props.onChange(returnObject);
    } else {
      if (!record) {
        props.onChange("");
      } else {
        props.onChange(record.companyUuid);
      }
    }
  }
  const handleInputChange = (event, value) => {
    if (!event || (event.type !== 'change' && !((event.type === 'blur' || event.type==='click') && (value || props.allowEmpty)))) return;
    if (props.returnType === "object") {
      const returnObject = props.allowEmpty && !value? { value: null, found: true, data: {companyName: "", companyUuid: null, companyCode: ""} } : { value, found: false, data: {} }
      const record = _.findWhere(records.data, { companyUuid: value });
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
        returnObject.value = record.companyUuid;
      }
      props.onChange(returnObject);
    } else {
      props.onChange(value);
    }
  }

  const DropdownList = function (props) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />;
  };

  const defaultFilterOptions = (options, state) => {
    if (state.inputValue) {
      const searchCode = state.inputValue.toUpperCase();
      const filteredOptions = _.filter(options, (company) => {
        const companyCode = company.companyCode||"";
        let companyName = company.companyName||"";
        if (company.branchCode) {
          companyName = `${company.companyName} (${company.branchCode})`;
        }
        return (companyCode.toUpperCase().startsWith(searchCode) || companyName.toUpperCase().indexOf(searchCode) >= 0)
      });
      return [...newCompany, ...filteredOptions];
    } else return options.slice(0, 300);
}
  const filterOptions = props.filterOptions || defaultFilterOptions;

  if (props.type === "render") {
    if (props.label) {
      if (props.hideCode) return ( 
        <Text id={props.id} label={props.label} fullWidth style={{padding: 0}} value={records.data && _.find(records.data, {companyUuid: props.value})?`${_.find(records.data, {companyUuid: props.value}).companyName}`:''}/>
      )
      return (
        <Text id={props.id} label={props.label} fullWidth style={{padding: 0}} value={records.data && _.find(records.data, {companyUuid: props.value})?`${_.find(records.data, {companyUuid: props.value}).companyCode} - ${_.find(records.data, {companyUuid: props.value}).companyName}`:''}/>
      )
    }
    if (props.hideCode) {
      return <div>{records.data && _.find(records.data, {companyUuid: props.value})?`${_.find(records.data, {companyUuid: props.value}).companyName}`:''}</div>
    }
    return <div>{records.data && _.find(records.data, {companyUuid: props.value})?`${_.find(records.data, {companyUuid: props.value}).companyCode} - ${_.find(records.data, {companyUuid: props.value}).companyName}`:''}</div>
  } else {
    return (
      <Autocomplete
        id={props.id}
        disableClearable={true}
        autoSelect={(records && records.data && !props.allowEmpty)?true:false}
        autoHighlight={true}
//        inputValue={records.data && _.find(records.data, {companyUuid: props.value})?!props.alwaysShowCompanyName?_.find(records.data, {companyUuid: props.value}).companyCode||_.find(records.data, {companyUuid: props.value}).companyName:_.find(records.data, {companyUuid: props.value}).companyName:props.value||""}
        inputValue={formatInputValue(props.value, records, props.alwaysShowCompanyName)}
        options={records.data||[]}
        filterOptions={filterOptions}
        PopperComponent={DropdownList}
        getOptionSelected={(option, value) => option.companyUuid === value.companyUuid}
        getOptionLabel={(option) => option.companyUuid}
        onChange={handleChange}
        onInputChange={handleInputChange}
        disabled={props.disabled||props.readOnly}
        renderOption={(option) => {
          let verified = false;
          if (option?.pioneerAccountId && option?.kycStatusCode && option?.kycExpiryDate) {
            if ([123340000, 418390003, 123340002, 418390002].includes(Number(option?.kycStatusCode))) {
              const expired = moment(option.kycExpiryDate).isBefore(moment());
              if (!expired)
                verified = true;
            }
          }
          return (
            <div>
              <Box
                component="img"
                sx={{
                  height: 30,
                  width: 35,
                  // maxHeight: { xs: 233, md: 167 },
                  // maxWidth: { xs: 350, md: 250 },
                }}
                alt="KYC"
                src={verified ? "images/KycVerified.png" : "images/KycUnverified.png"}
                style={{marginRight: 10, marginBottom: -5}}
              />
              <React.Fragment key={`company-lookup-${option.companyCode}`}>
                {option.companyCode}{option.companyCode ? " - " : ""}{option.companyName}{!props.atAirport && option.branchCode?` (${option.branchCode})`:''}
              </React.Fragment>
            </div>
          )
        }}
        style={{
          width: (props.width||"100%"),
        }}
        renderInput={(params) => {
          let value = params.inputProps.value||"";
          const record = _.find(records.data, {companyUuid: value});
          if (record) {
            value = record.companyName||"";
          }
          const extraProps = {};
          if (props.readOnly) {
            extraProps.className = classes.readOnly;
          }
          const inputProps = {
            ...props.inputProps,
            ...params.inputProps,
            ...extraProps,
            value
          }
          return (<TextField
            {...params}
            label={props.label}
            placeholder={props.placeHolder}
            inputProps={{...inputProps}}
            InputLabelProps={{shrink: props.shrink}}
          />)
        }}
      />
    )
  }
}

export default withStyles(styles) (CompanyUuidLookup);
export {
  CompanyUuidLookup as companyUuidLookup
}
